import { render, staticRenderFns } from "./TheTextos.vue?vue&type=template&id=98db59fa&scoped=true&"
import script from "./TheTextos.vue?vue&type=script&lang=js&"
export * from "./TheTextos.vue?vue&type=script&lang=js&"
import style0 from "./TheTextos.vue?vue&type=style&index=0&id=98db59fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98db59fa",
  null
  
)

export default component.exports